"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ThumbDown16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_4141_1474)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.06152 11C1.10451 11 -0.328526 9.15649 0.154228 7.25996L1.2352 3.01328C1.6864 1.24071 3.28249 -1.59905e-07 5.11159 0L16.0022 9.52089e-07L16.0022 10H12.0022L10.3441 14.9743C10.1399 15.5869 9.56672 16 8.92108 16H8.86967C7.05514 16 5.58822 14.6271 5.39172 12.901C5.36398 12.6573 5.36156 12.4066 5.38704 12.1517L5.49122 11.11C5.49711 11.0511 5.45088 11 5.39172 11H3.06152ZM10.0022 9.67544L10.0022 2L5.11159 2C4.19704 2 3.399 2.62035 3.17339 3.50664L2.09242 7.75332C1.9315 8.3855 2.40918 9 3.06152 9H5.39172C6.63413 9 7.60492 10.0727 7.4813 11.309L7.37712 12.3507C7.29902 13.1317 7.83237 13.8213 8.5706 13.9703L10.0022 9.67544ZM12.0022 8H14.0022L14.0022 2H12.0022L12.0022 8Z", fill: "#131416" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_4141_1474" },
                react_1.default.createElement("rect", { width: 16, height: 16, fill: "white" }))));
}
function ThumbDown16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ThumbDown16Svg, Object.assign({}, svgProps)));
}
exports.default = ThumbDown16;
//# sourceMappingURL=ThumbDown16.js.map